import { render, staticRenderFns } from "./lawyer.vue?vue&type=template&id=9f170094"
import script from "./lawyer.vue?vue&type=script&lang=js"
export * from "./lawyer.vue?vue&type=script&lang=js"
import style0 from "./lawyer.vue?vue&type=style&index=0&id=9f170094&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports